/*

class to generate notification

{
  "state" : "<code>" // active || pending || archive || delete,
  "workspaceId" : "<string>" // Plain text representation of the concept
  "workspaceType" : "<code>", // general || organization || team || eoc
  "channelId" : "<string>" // Plain text representation of the concept
  "notificationId" : "<string>",
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, NOTIFICATION_TYPES, WORKSPACE_TYPES, CHANNEL_TYPES, USER_TYPES } = require('@bcm/constants');
const { NotificationTableBase } = require('./base.class');
const { joiValidateObj, identifiers } = require('../datastructComponents');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userId: Joi.string().required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  notificationType: Joi.string().valid( ...Object.keys( NOTIFICATION_TYPES) ).required(),
  notificationId: Joi.string().required(),
  payload: Joi.object().required(),
  workspaceType: Joi.string().valid( ...Object.keys(WORKSPACE_TYPES) ).optional(),
  workspaceId: Joi.string().optional(),
  channelType: Joi.string().valid( ...Object.keys(CHANNEL_TYPES) ).optional(),
  channelId: Joi.string().optional(),
  messageId: Joi.string().optional(),
  eocId: Joi.string().optional(),
  imageId: Joi.string().optional(),
  conditionId: Joi.string().optional(),
  bodySiteId: Joi.string().optional(),
  annotationId: Joi.string().optional(),
  imageSetId: Joi.string().optional(),
  orgId: Joi.string().optional(),
};

// Define class
class Notification extends NotificationTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super(
      identifiers.notification.buildPk(obj.userId),
      identifiers.notification.buildSk(obj.state, obj.userId, obj.notificationId),
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Notification = Notification;
exports.notificationSchema = schema;